import { pushEvent, pushData } from '../../utils/datalayer';
import { intersectionViewportObserver } from 'Utils/';

const UAEVENT = 'uaevent';
let initialProductData = [];

export const tagging = {
  name: 'lp-tagging',
  inserted: (el, binding) => {
    const { arg } = binding;

    if (arg === 'navclick') {
      el.addEventListener('click', () => {
        const mql = window.matchMedia('(max-width: 1024px)');
        // Mobile - Only clicks, no hover
        if (mql.matches) {
          pushEvent({
            event: UAEVENT,
            event_name: 'menu_click',
            click_area: 'burger menu',
            breadcrumb: binding.value.label,
          });
        }
        // Desktop
        else {
          pushEvent({
            event: UAEVENT,
            event_name: 'menu_click',
            click_area: 'header',
            breadcrumb: binding.value.label,
          });
        }
      });
    }

    // Accordinon Open Tagging
    // Checks isClosing from the details accordion directive
    if (arg === 'detailopen') {
      const data = binding.value.data;
      const eventData = typeof data === 'string' ? JSON.parse(data) : data;
      const onToggle = () => {
        if (el.open) return;
        pushEvent(eventData);
      };
      el.querySelector('summary').addEventListener('click', onToggle);
    }

    if (
      binding.value &&
      (arg === 'productclick' || arg === 'productimpression' || arg === 'ctaclicktag')
    ) {
      const data = binding.value.data;
      const editData = typeof data === 'string' ? JSON.parse(data) : data;
      const onEvent = function (event) {
        if (event.type === 'click' && (arg === 'productclick' || arg === 'ctaclicktag')) {
          pushEvent(editData);
        }
      };
      const onImpression = function () {
        if (arg === 'productimpression') {
          initialProductData.push(editData);
          setTimeout(function () {
            if (initialProductData.length > 0) {
              let processedProductData = initialProductData.reduce(function (
                s,
                a
              ) {
                s = [...s, ...a.ecommerce.impressions];
                return s;
              },
              []);
              let processedDataLayerImpression = initialProductData[0];
              processedDataLayerImpression.ecommerce.impressions =
                processedProductData;
              pushEvent(processedDataLayerImpression);
              initialProductData = [];
            }
          }, 700);
        }
      };
      el.addEventListener('click', onEvent);
      intersectionViewportObserver(el, { checkIsVisible: true }).then(
        onImpression
      );
    }

    if (arg === 'pagedata') {
      const data = binding.value.data;
      const sendData = typeof data === 'string' ? JSON.parse(data) : data;
      pushData(sendData);
    }

    if (arg === 'onvisible') {
      const data = binding.value.data;
      const editData = typeof data === 'string' ? JSON.parse(data) : data;
      intersectionViewportObserver(el, { checkIsVisible: true }).then(() =>
        pushEvent(editData)
      );
    }
  },
};
